import { Component, OnInit } from '@angular/core';
import { BsDatepickerConfig, DatepickerDateCustomClasses } from 'webcommon/ap-ngx-bootstrap/datepicker';
import { ApBaseModalComponent } from 'webcommon/core-ui';
import {ApCustomDateRange, BsDatepickerValue} from 'webcommon/shared';
@Component({
  selector: 'ap-timespan-modal-component',
  styleUrls: ['./ap-timespan-selector-modal.component.less'],
  templateUrl: './ap-timespan-selector-modal.component.html',
})
export class ApTimeSpanSelectorModalComponent extends ApBaseModalComponent<ApCustomDateRange> implements OnInit {
  Id: string;
  baseId: string;
  startDate: BsDatepickerValue = undefined;
  endDate: BsDatepickerValue = undefined;
  bsConfig: Partial<BsDatepickerConfig>;
  colorTheme = 'theme-emds-datepicker';
  dateCustomClasses: DatepickerDateCustomClasses[];

  // This component has logic to swap dates if the chosen end date is earlier than the start date,
  // or if the chosen start date is later than the end date.
  // It will no longer error out for these two scenarios, but instead will swap the dates with a
  // message informing the user.

  // activates the UI swap message
  isSwap = false;

  // message content telling the user they put in a date in reverse order
  swapMessage = '';

  override ngOnInit() {
    super.ngOnInit();
    this.setupId();
    this.bsConfig = Object.assign(
      { adaptivePosition: true },
      { containerClass: this.colorTheme },
      { dateInputFormat: 'M/D/YYYY' },
      { showWeekNumbers: false },
      { selectFromOtherMonth: true },
    );

    const now = new Date();
    this.dateCustomClasses = [
      { date: now, classes: ['emds-datepicker-current-date-background-color'] },
    ];
  }

  setupId() {
    this.Id = this.baseId + '-timespan-selector';
  }

  isDateValid(date: Date | BsDatepickerValue | null) {
    return date && !isNaN(date.getDate());
  }

  areBothDateEntriesValid() {
    return this.isDateValid(this.startDate) && this.isDateValid(this.endDate);
  }

  canSave() {
    return this.isDateRangeValid();
  }

  isDateRangeValid() {
    return this.startDate && this.endDate
      && this.areBothDateEntriesValid()
      && (this.startDate <= this.endDate);
  }

  onStartDateChanged(): void {
    this.validateAndSwapDateRange(true);
  }

  onEndDateChanged(): void {
    this.validateAndSwapDateRange(false);
  }

  validateAndSwapDateRange(dateChangedIsStartDate: boolean) {
    if (!(this.startDate && this.endDate && this.areBothDateEntriesValid())) return;
    // strip out any possibility of a set time component to compare dates only
    this.startDate = new Date(this.startDate.getFullYear(), this.startDate.getMonth(), this.startDate.getDate());
    this.endDate = new Date(this.endDate.getFullYear(), this.endDate.getMonth(), this.endDate.getDate());
    if (!this.isDateRangeValid()) {
      this.isSwap = true;
      this.swapMessage = 'Start and end dates have been swapped because you entered the '
          + ((dateChangedIsStartDate) ? 'start' : 'end')
          + ' date of '
          + ((dateChangedIsStartDate) ? this.startDate.toLocaleDateString() : this.endDate.toLocaleDateString())
          + ', which is '
          + ((dateChangedIsStartDate) ? 'later' : 'earlier')
          + ' than the '
          + ((dateChangedIsStartDate) ? 'end' : 'start')
          + ' date of '
          + ((dateChangedIsStartDate) ? this.endDate.toLocaleDateString() : this.startDate.toLocaleDateString())
          + '.';
      const temp = this.startDate;
      this.startDate = this.endDate;
      this.endDate = temp;
    } else {
      this.isSwap = false;
      this.swapMessage = '';
    }
  }

  close() {
    if (this.canSave()) {
      super.closeModal({
        EndDate: this.endDate,
        StartDate: this.startDate,
      });
    }
  }

  cancel() {
    super.dismissModal();
  }
}
